var React = require('react');

function Pie (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M850.786,500.158l-25.9-.1-.1,26c14.306.054,25.937-8.982,25.979-20.182Z","transform":"translate(-824.786 -500.061)","fill":"currentColor"}));
}

Pie.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = Pie;

Pie.default = Pie;
